import { config } from "../../../config"
import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Badge, Button, Input, Label } from "reactstrap";

import { useParams } from "react-router-dom";
import moment from 'moment-timezone';
import { useDispatch, useSelector } from "react-redux";

import { posApi, selectPosById } from "../reducers/posSlice";
import { posAnalyticsApi, clearPosDataList } from "../reducers/posAnalyticsSlice";
import { clearSurveyList } from "../reducers/surveySlice";
import { PosAnalyticsModel } from "../models/PosAnalyticsModel";
import PosDataFilter from "./pos/PosDataFilter";
import PosAnalytics from "./pos/PosAnalytics";
import SurveyList from "./survey/SurveyList";

const PointOfSaleData = () => {
  const { id } = useParams()
  const token = useSelector((state) => state.identityReducer.token );
  const filters = useSelector((state) => state.posAnalyticsReducer.filters);
  const pos = useSelector((state) => selectPosById(state, id));
  const fromDate = useSelector((state) => state.posAnalyticsReducer.fromDate);
  const toDate = useSelector((state) => state.posAnalyticsReducer.toDate);
  const groupBy = useSelector((state) => state.posAnalyticsReducer.groupBy);
  const [colors, setColors] = useState([])
  const [showHidden, setShowHidden] = useState(false)

  const dispatch = useDispatch();

  const getDownloadUrl = (ext) => {
    let url = config.baseurl + "/api/v1/pos/"+id+"/survey/export."+ext+"?apikey="+config.apiKey+"&token="+token.signature+"&sort=area_id:ASC|closed_at:ASC"
    let from = null
    let to = null
    
    if(fromDate) {
      fromDate.set({hour:0,minute:0,second:0,millisecond:0})
      from = fromDate ? moment.tz(fromDate.format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss', 'UTC').format() : null;
    }
    
    if(toDate ) {
      toDate.set({hour:23,minute:59,second:59,millisecond:999})
      to = toDate ? moment.tz(toDate.format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss', 'UTC').format() : null;
    }

    if(from && to) {
      url = url + "&closed_at[range]="+from+":"+to
    } else {
      if(from) url = url + "&closed_at[gte]="+from
      if(to) url = url + "&closed_at[lte]="+to
    }
    return url
  }

  useEffect(() => {
    if(id > 0) {
      dispatch(clearSurveyList())
      dispatch(posApi.fetchById({id: id}))
    }
  }, [id, dispatch])

  useEffect(() => {
    if(pos && fromDate && toDate) {
      dispatch(clearPosDataList())

      fromDate.set({hour:0, minute:0, second:0, millisecond:0})
      toDate.set({hour:23, minute:59, second:59, millisecond:999})

      let from = fromDate ? moment.tz(fromDate.format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss', 'UTC').format() : null;
      let to = toDate ? moment.tz(toDate.format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss', 'UTC').format() : null;

      let areaColors = []
      pos.areas.forEach((area) => {
        areaColors.push({name: area.name, color: area.color})

        dispatch(posAnalyticsApi.fetchAll({
          name: area.name,
          type: PosAnalyticsModel.TYPE_AVG_SCORE,
          group: groupBy,
          fromDate: from,
          toDate: to,
          filters: { ...filters, pos_id: parseInt(id), area_id: area.id }
        }))
      })
      setColors(areaColors)
    }

  }, [dispatch, id, pos, filters, fromDate, toDate, groupBy])

    
  const getUserCanoncial = (user) => {
    let canonical = "-"
    if(user) {
      canonical = `${user.first_name} ${user.last_name}`.trim()
      canonical = canonical.length > 0 ? canonical : user.email
    }
    return canonical
  }

  const ckBoxStyle = { marginRight: '5px', height: '20px', width: '20px', position: 'relative', top: '-4px'}

  return (
    <div className="app-drawer">
        <Row className="border-bottom">
          <Col md="8"><h1>{pos ?<> <b>{pos.code}</b> - {pos.company_name}</>: "..."}</h1></Col>
          <Col md="4">
          {
            pos 
            ? <div className="float-end">
              { pos.sign ? <Badge color="primary" style={{fontSize: '12px', marginLeft: '2px'}} pill>{pos.sign}</Badge> : <></>}
              { pos.group ? <Badge color="secondary" style={{fontSize: '12px', marginLeft: '2px'}} pill>{pos.group}</Badge> : <></>}
              { pos.type ? <Badge color="info" style={{fontSize: '12px', marginLeft: '2px'}} pill>{pos.type}</Badge> : <></>}
            </div>
            : null
          }
          </Col>
        </Row>
        <Row>
          <Col md="8" className="pt-2 pb-4">{pos ? `${pos.address} ${pos.address_number}, ${pos.cap} ${pos.city} (${pos.province})` : "..."}</Col>
          <Col md="4"><div className="float-end"><b>{ pos ? getUserCanoncial(pos.user) : "..." }</b></div></Col>
        </Row>
        <PosDataFilter groupByModes={[
          {value: PosAnalyticsModel.GROUP_DAILY, label: "giornaliero"},
          {value: PosAnalyticsModel.GROUP_MONTHLY, label: "mensile"},
          {value: PosAnalyticsModel.GROUP_YEARLY, label: "annuale"},
        ]}/>
        <Card  className="mt-4">
          <CardBody>
            <Row className="p-4">
                <Col md="12" >
                  <PosAnalytics 
                    colors={colors}
                    width="100%"
                    height="300"
                  />
                </Col>
            </Row>
          </CardBody>
        </Card>
        <Row>
          <Col md="6">
            {/* <CustomInput type="checkbox" id="showHidden" label="visualizza in sospeso" checked={showHidden} style={{fontSize:"13px", fontStyle: 'italic'}}
                onChange={(e) => {
                  setShowHidden(!showHidden)
                }}
            /> */}
            <span style={{position: 'relative', top: '10px'}}>
              <Input type="switch" id="showHidden" name="showHidden" checked={showHidden} style={ckBoxStyle}
                onChange={(e) => {
                  setShowHidden(!showHidden)
                }}
              />
              <Label>Visualizza in sospeso</Label>
            </span>
          </Col>
          <Col md="6" style={{textAlign: 'right'}}>
            <Button 
                id="download_prd_btn" 
                href={getDownloadUrl("pdf")}
                tag="a"
                color="secondary" 
                style={{marginLeft: "5px"}} 
            >
                <span className="fas fa-download"></span> PDF
            </Button>
            <Button 
                id="download_csv_btn" 
                href={getDownloadUrl("csv")}
                tag="a"
                color="secondary" 
                style={{marginLeft: "5px"}} 
            >
                <span className="fas fa-download"></span> CSV
            </Button>
          </Col>
        </Row>
        <Row>
            <Col md="12">
              {
                pos 
                  ? pos.areas.map((area) => (
                    <div key={area.id}>
                      <Card  className="mt-4">
                        <CardBody>
                          <Row >
                            <Col md="12">
                              <h2 style={{paddingLeft: "1.25rem", color: area.color, whiteSpace: 'nowrap'}}>
                                <div style={{width: '20px', height: '20px', backgroundColor: area.color, display: 'inline-block', position: 'relative', top: '1px', marginRight: '5px'}}></div>
                                {area.name}
                              </h2>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                              <SurveyList pos_id={id} area_id={area.id} showHidden={showHidden}/>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </div>
                    )) 
                  : null
              }
            </Col>
        </Row>
    </div>
  );
};

export default PointOfSaleData;